import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import util from './common/util'
import './assets/styles/iconfont.css'
import './assets/styles/main.less'
import './index.less'

import iView from 'iview';
import 'iview/dist/styles/iview.css';

// 引入外部表格；
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'


// 懒加载
import VueLazyload from 'vue-lazyload';

// iView 和 iView Pro
import ViewUI from 'view-design';

// 插件
import plugins from '@/plugins';

Vue.use(ElementUI);
Vue.use(plugins);
Vue.use(iView);
Vue.use(VXETable);

Vue.use(ViewUI, {
});

Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999
    }
});

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: require('./assets/images/no.png'),
    loading: require('./assets/images/moren.jpg'),
    attempt: 1,
    listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove']
});

// store
import store from '@/store/index';

Vue.config.productionTip = false
// let baseURL = 'http://127.0.0.1/vmwarebt/lxgyl/lxgyl_back/public'
//var baseURL = 'https://jmapi.zxk.xm0592.com'  //简米供应链
var baseURL = 'https://api.lx.xm0592.com'  //朗悉_十鹿
axios.defaults.baseURL = baseURL
axios.interceptors.request.use(config => {
    let token = localStorage.token
    if (token)
        config.headers['Access-Token'] = token
    return config
})
axios.interceptors.response.use(response => {
    if (response.data.code == 1) {
        return response.data
    } else {
        if (!response.data.msg) {
            response.data.msg = response.data.message ? response.data.message : '请求异常'
        }

        ElementUI.Message.error({
            message: response.data.msg
        });
    }
    return Promise.reject(response.data.msg);
}, error => {
    if (error.response.status == 400) {
        ElementUI.Message.error({
            message: error.response.data.msg
        });
    } else if (error.response.status == 402) {
        localStorage.clear()
        router.replace({path: '/login.html'});
        // router.replace({path:'/Blurb/index.html'});
    } else {
        if (error.response.data && error.response.data.msg) {
            ElementUI.Message.error({
                message: error.response.data.msg
            });
        } else {
            ElementUI.Message.error({
                message: '请求异常'
            });
        }

    }
    return Promise.reject(error.response.data.msg);
})
Vue.prototype.axios = axios
Vue.prototype.app_url = baseURL
Vue.prototype.$check = util.formCheck
Vue.prototype.pageSizeNume = 1000
Vue.prototype.page = 1

Vue.directive('width',{
    bind(el,binding,vnode){
        const { value } = binding;
        el.style.width = Number(value) ? String(value).concat('px') : value
    }
})

new Vue({
    render: h => h(App),
    store,
    router
}).$mount('#app')
